module.exports = __webpack_public_path__ + "static/media/infographic.4a2a0327.png";